var map = {
	"./": 18063,
	"./App": 37968,
	"./App.css": 44050,
	"./App.js": 37968,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./PageRender": 28867,
	"./PageRender.jsx": 28867,
	"./Routes": 53976,
	"./Routes.jsx": 53976,
	"./components/RevenueImpactChart": 68849,
	"./components/RevenueImpactChart.jsx": 68849,
	"./components/Search": 24985,
	"./components/Search.jsx": 24985,
	"./components/Tables": 44528,
	"./components/Tables.jsx": 44528,
	"./components/UsersComposition": 24529,
	"./components/UsersComposition.jsx": 24529,
	"./components/button/Btn": 4094,
	"./components/button/Btn.jsx": 4094,
	"./components/card": 72145,
	"./components/card.jsx": 72145,
	"./components/customDropzone": 40927,
	"./components/customDropzone.jsx": 40927,
	"./components/modal": 94812,
	"./components/modal.jsx": 94812,
	"./components/pages/LeaderBoard/LeaderBoardHeader": 55184,
	"./components/pages/LeaderBoard/LeaderBoardHeader.jsx": 55184,
	"./components/pages/LeaderBoard/ThisMonth": 94920,
	"./components/pages/LeaderBoard/ThisMonth.jsx": 94920,
	"./components/pages/LeaderBoard/ThisWeek": 98516,
	"./components/pages/LeaderBoard/ThisWeek.jsx": 98516,
	"./components/pages/LeaderBoard/Today": 86413,
	"./components/pages/LeaderBoard/Today.jsx": 86413,
	"./components/pages/LeaderBoard/TopUser": 28430,
	"./components/pages/LeaderBoard/TopUser.jsx": 28430,
	"./components/pages/Notification/NewNotification": 28735,
	"./components/pages/Notification/NewNotification.jsx": 28735,
	"./components/pages/Notification/NotificationDetail": 34532,
	"./components/pages/Notification/NotificationDetail.jsx": 34532,
	"./components/pages/Notification/NotificationList": 3271,
	"./components/pages/Notification/NotificationList.jsx": 3271,
	"./components/pages/classActivity/Card": 42268,
	"./components/pages/classActivity/Card.jsx": 42268,
	"./components/pages/classActivity/ClassActivityBtn": 45351,
	"./components/pages/classActivity/ClassActivityBtn.jsx": 45351,
	"./components/pages/classActivity/EditClassroom": 35289,
	"./components/pages/classActivity/EditClassroom.jsx": 35289,
	"./components/pages/classActivity/UploadClassWork": 955,
	"./components/pages/classActivity/UploadClassWork.jsx": 955,
	"./components/pages/classActivity/allAssignment": 60018,
	"./components/pages/classActivity/allAssignment.jsx": 60018,
	"./components/pages/classActivity/classActivityHeader": 44900,
	"./components/pages/classActivity/classActivityHeader.jsx": 44900,
	"./components/shared/Sidebar": 8517,
	"./components/shared/Sidebar.jsx": 8517,
	"./components/shared/Topbar": 47557,
	"./components/shared/Topbar.jsx": 47557,
	"./components/shared/navbar": 49531,
	"./components/shared/navbar.jsx": 49531,
	"./data/Config": 1155,
	"./data/Config.js": 1155,
	"./data/Context": 52860,
	"./data/Context.jsx": 52860,
	"./data/Reducers": 46795,
	"./data/Reducers/": 46795,
	"./data/Reducers/ErrorReducer": 50309,
	"./data/Reducers/ErrorReducer.js": 50309,
	"./data/Reducers/UserReducer": 73830,
	"./data/Reducers/UserReducer.js": 73830,
	"./data/Reducers/index": 46795,
	"./data/Reducers/index.js": 46795,
	"./data/Store": 45432,
	"./data/Store.js": 45432,
	"./fonts/Satoshi-Black.eot": 48948,
	"./fonts/Satoshi-Black.ttf": 53854,
	"./fonts/Satoshi-Black.woff": 11998,
	"./fonts/Satoshi-Black.woff2": 25944,
	"./fonts/Satoshi-BlackItalic.eot": 90032,
	"./fonts/Satoshi-BlackItalic.ttf": 60426,
	"./fonts/Satoshi-BlackItalic.woff": 41786,
	"./fonts/Satoshi-BlackItalic.woff2": 20556,
	"./fonts/Satoshi-Bold.eot": 31522,
	"./fonts/Satoshi-Bold.ttf": 76220,
	"./fonts/Satoshi-Bold.woff": 54700,
	"./fonts/Satoshi-Bold.woff2": 94310,
	"./fonts/Satoshi-BoldItalic.eot": 88738,
	"./fonts/Satoshi-BoldItalic.ttf": 42492,
	"./fonts/Satoshi-BoldItalic.woff": 50156,
	"./fonts/Satoshi-BoldItalic.woff2": 60070,
	"./fonts/Satoshi-Italic.eot": 35151,
	"./fonts/Satoshi-Italic.ttf": 91153,
	"./fonts/Satoshi-Italic.woff": 92919,
	"./fonts/Satoshi-Italic.woff2": 78807,
	"./fonts/Satoshi-Light.eot": 8857,
	"./fonts/Satoshi-Light.ttf": 75811,
	"./fonts/Satoshi-Light.woff": 62561,
	"./fonts/Satoshi-Light.woff2": 29617,
	"./fonts/Satoshi-LightItalic.eot": 50913,
	"./fonts/Satoshi-LightItalic.ttf": 47483,
	"./fonts/Satoshi-LightItalic.woff": 12793,
	"./fonts/Satoshi-LightItalic.woff2": 5177,
	"./fonts/Satoshi-Medium.eot": 80554,
	"./fonts/Satoshi-Medium.ttf": 40628,
	"./fonts/Satoshi-Medium.woff": 63012,
	"./fonts/Satoshi-Medium.woff2": 35406,
	"./fonts/Satoshi-MediumItalic.eot": 66330,
	"./fonts/Satoshi-MediumItalic.ttf": 59780,
	"./fonts/Satoshi-MediumItalic.woff": 26644,
	"./fonts/Satoshi-MediumItalic.woff2": 59230,
	"./fonts/Satoshi-Regular.eot": 33785,
	"./fonts/Satoshi-Regular.ttf": 75619,
	"./fonts/Satoshi-Regular.woff": 58529,
	"./fonts/Satoshi-Regular.woff2": 95729,
	"./fonts/Satoshi-Variable.eot": 97039,
	"./fonts/Satoshi-Variable.ttf": 30801,
	"./fonts/Satoshi-Variable.woff": 82135,
	"./fonts/Satoshi-Variable.woff2": 97751,
	"./fonts/Satoshi-VariableItalic.eot": 53867,
	"./fonts/Satoshi-VariableItalic.ttf": 27133,
	"./fonts/Satoshi-VariableItalic.woff": 80819,
	"./fonts/Satoshi-VariableItalic.woff2": 88907,
	"./hooks/useCustomDropzone": 68108,
	"./hooks/useCustomDropzone.jsx": 68108,
	"./index": 18063,
	"./index.css": 59555,
	"./index.js": 18063,
	"./logo.svg": 69445,
	"./pages": 56357,
	"./pages/": 56357,
	"./pages/classroom": 99329,
	"./pages/classroom/": 99329,
	"./pages/classroom/AddAssignment": 61031,
	"./pages/classroom/AddAssignment.jsx": 61031,
	"./pages/classroom/AssignmentView": 70113,
	"./pages/classroom/AssignmentView.jsx": 70113,
	"./pages/classroom/classActivity": 67234,
	"./pages/classroom/classActivity.jsx": 67234,
	"./pages/classroom/index": 99329,
	"./pages/classroom/index.jsx": 99329,
	"./pages/dashboard": 16116,
	"./pages/dashboard/": 16116,
	"./pages/dashboard/index": 16116,
	"./pages/dashboard/index.jsx": 16116,
	"./pages/index": 56357,
	"./pages/index.jsx": 56357,
	"./pages/leaderboard": 50373,
	"./pages/leaderboard/": 50373,
	"./pages/leaderboard/index": 50373,
	"./pages/leaderboard/index.jsx": 50373,
	"./pages/lessons": 60315,
	"./pages/lessons/": 60315,
	"./pages/lessons/add-topic-form": 91086,
	"./pages/lessons/add-topic-form.jsx": 91086,
	"./pages/lessons/course-detail": 54860,
	"./pages/lessons/course-detail.jsx": 54860,
	"./pages/lessons/edit-subject": 69560,
	"./pages/lessons/edit-subject.jsx": 69560,
	"./pages/lessons/index": 60315,
	"./pages/lessons/index.jsx": 60315,
	"./pages/lessons/new-subjects": 35651,
	"./pages/lessons/new-subjects.jsx": 35651,
	"./pages/lessons/pass-mark": 77160,
	"./pages/lessons/pass-mark.jsx": 77160,
	"./pages/lessons/subject-details": 29478,
	"./pages/lessons/subject-details.jsx": 29478,
	"./pages/lessons/topic-assessment": 48335,
	"./pages/lessons/topic-assessment.jsx": 48335,
	"./pages/notification": 93781,
	"./pages/notification/": 93781,
	"./pages/notification/index": 93781,
	"./pages/notification/index.jsx": 93781,
	"./pages/performance": 49466,
	"./pages/performance/": 49466,
	"./pages/performance/index": 49466,
	"./pages/performance/index.jsx": 49466,
	"./pages/performance/performancePage": 87717,
	"./pages/performance/performancePage.jsx": 87717,
	"./pages/profile": 15675,
	"./pages/profile/": 15675,
	"./pages/profile/editProfile": 36976,
	"./pages/profile/editProfile.jsx": 36976,
	"./pages/profile/index": 15675,
	"./pages/profile/index.jsx": 15675,
	"./pages/questions-portal": 38442,
	"./pages/questions-portal/": 38442,
	"./pages/questions-portal/index": 38442,
	"./pages/questions-portal/index.jsx": 38442,
	"./pages/students": 47508,
	"./pages/students/": 47508,
	"./pages/students/[id]": 46767,
	"./pages/students/[id].jsx": 46767,
	"./pages/students/index": 47508,
	"./pages/students/index.jsx": 47508,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./screens/home": 65784,
	"./screens/home.jsx": 65784,
	"./screens/login": 29457,
	"./screens/login.jsx": 29457,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./styles/fonts.css": 27638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;